export const DASHBOARD = '/';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const USERS = '/users';
export const RENTS = '/rents';
export const RENT_LLD = '/lld-rents';
export const RENTERS = '/renters';
export const RENTER_ADD = '/renters/add';
export const RENTER = '/renters/:renterId';
export const RENTER_EDIT = '/renters/:renterId/edit';
export const BIKES = '/bikes';
export const BIKE_ADD = '/bikes/add';
export const BIKE = '/bikes/:bikeId';
export const SITES = '/sites';
export const SITE = '/sites/:siteId';
export const SITE_ADD = '/sites/add';
export const VOUCHERS = '/vouchers';
export const VOUCHERS_ADD = '/vouchers/add';
export const VOUCHERS_EDIT = '/vouchers/:voucherId';
export const EDIT_PROFILE = '/account/edit';
export const PASSWORD_FORGET = '/pw-forget';
export const PASSWORD_CHANGE = '/pw-change';
export const INVITE_RENTER = '/invite/:inviteToken';
export const BOOKINGS = '/books';
export const BOOKINGS_LLD = '/lld-books';
export const FEEDBACKS = '/feedbacks'



// WEBPACK FOOTER //
// ./src/constants/routes.js